import { HttpError, type DataProvider, type UpdateParams } from "ra-core";

/**
 * An update of the configuration row replaces the whole config (one jsonb
 * column), and the Settings form only knows its own keys. Merge the new
 * config over the stored one so other keys (telephony, set by SQL; future
 * ones) survive every save. When the stored config cannot be read, the save
 * stops with an error (it would otherwise drop those keys).
 */
export const keepConfigKeys = async (
  params: UpdateParams,
  dataProvider: DataProvider,
): Promise<UpdateParams> => {
  const config = params.data?.config;
  if (!config || typeof config !== "object") return params;
  let stored: Record<string, unknown>;
  try {
    const { data } = await dataProvider.getOne("configuration", { id: 1 });
    stored = (data?.config as Record<string, unknown>) ?? {};
  } catch {
    // without the stored config the save would keep only the form's keys and
    // drop the others (telephony, mail, Bitrix24…): stop instead
    throw new HttpError(
      "Не удалось прочитать настройки, ничего не сохранено. Попробуйте ещё раз",
      503,
    );
  }
  return {
    ...params,
    data: { ...params.data, config: { ...stored, ...config } },
  };
};
